<template>
  <div :class="$style.header">
    <div :class="$style.left">
    </div>
    <div :class="$style.right">
      <!-- <div :class="$style.divder"></div> -->
      <template v-if="store?.state?.isAuthenticated">
        <a-dropdown :trigger="['click']">
          <a @click.prevent :class="[$style.itemR, $style.user]">
            {{ store?.state?.user?.username || "-" }}
            <DownOutlined :class="$style.downIcon" />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item key="2" @click="handleLogout">
                <a>{{ $t('header.logout') }}</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
      <template v-else>
        <a @click="navigateToLogin" :class="$style.itemR">{{ $t('header.login') }}</a>
        <a @click="navigateToRegister" :class="$style.itemR">{{ $t('header.register') }}</a>
      </template>
      <div :class="$style.divder"></div>
      <!-- <div :class="[$style.itemR, $style.languageSwitcher]" @click="toggleLanguage">
        {{ currentLanguage === 'en' ? 'English' : '中文' }}
      </div> -->
      <!-- <div :class="$style.divder"></div> -->
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { DownOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const store = useStore();
const router = useRouter();
const { locale } = useI18n();
const currentLanguage = ref(locale.value);

// 切换语言
const toggleLanguage = () => {
  const newLang = currentLanguage.value === 'en' ? 'zh' : 'en';
  currentLanguage.value = newLang;
  locale.value = newLang;
  localStorage.setItem('preferred_lang', newLang);
  window.location.reload()
};


// 处理登出
const handleLogout = async () => {
  try {
    await store.dispatch('logout');
    router.push('/login');
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

// 导航到登录页面
const navigateToLogin = () => {
  router.push('/login');
};

// 导航到注册页面
const navigateToRegister = () => {
  router.push('/register');
};
</script>

<style module>
  .header {
    width: 100%;
    height: 44px;
    background-color: #3149ff;
    padding: 0 230px;
    display: flex;
    justify-content: space-between;
  }
  .left {
    display: flex;
    align-items: center;
  }
  .leftL {
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    padding-right: 13px;
  }
  .leftC {
    width: 20px;
    margin-right: 9px;
    cursor: pointer;
  }
  .leftR {
    font-size: 12px;
    color: #ffe202;
  }
  .right {
    display: flex;
    align-items: center;
  }
  .divder {
    height: 20px;
    width: 0;
    border-right: 1px solid #fff;
  }
  .itemR {
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    margin-right: 28px;
    font-size: 14px;
    color: #ffffff;
  }
  .money {
    margin-left: 28px;
  }
  .user {
    margin-left: 28px;
  }
  .downIcon {
    margin-left: 10px;
  }
  .languageSwitcher {
    margin-left: 28px;
    cursor: pointer;
  }
</style>
